import { API } from '../../lib/api';

export const logout = () => {
  sessionStorage.clear();
  API.POST('reauthorize/logout', {});
};
